import React, { useState } from 'react';
import { Capacitor } from '@capacitor/core';
import { App as CapacitorApp } from '@capacitor/app';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(err.response?.data?.detail || '로그인에 실패했습니다.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-screen">
      {Capacitor.isNativePlatform() && (
        <button
          className="login-exit-btn"
          type="button"
          title="앱 종료"
          onClick={() => CapacitorApp.exitApp()}
        >
          ✕
        </button>
      )}
      <form className="login-card" onSubmit={handleSubmit}>
        <h1 className="login-title" translate="no">경북항공기술교육원 운영관리</h1>
        <p className="login-subtitle">교사 계정으로 로그인하세요</p>

        <label className="field-label">이메일</label>
        <input
          className="field-input"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="teacher1@school.kr"
          required
          autoFocus
        />

        <label className="field-label">비밀번호</label>
        <input
          className="field-input"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="••••••••"
          required
        />

        {error && <div className="login-error">{error}</div>}

        <button className="btn-primary" type="submit" disabled={submitting}>
          {submitting ? '로그인 중...' : '로그인'}
        </button>
      </form>
    </div>
  );
}
